import type { Organization } from "@/lib/data";
import { OrganizationContext } from "@/lib/use-organization";

export function OrganizationProvider({
  organization,
  children,
}: {
  organization: Organization;
  children: React.ReactNode;
}) {
  return (
    <OrganizationContext value={organization}>{children}</OrganizationContext>
  );
}
